import {array, string, type, TypeOf} from 'io-ts';

export const ServiceOptionSchema = type({
    name: string,
    key: string,
    icon: string,
});

export const TransactionOptionSchema = type({
    name: string,
    key: string,
    for_services: array(string),
});

export const AssetOptionSchema = type({
    name: string,
    key: string,
    icon: string,
    for_services: array(string),
    for_transactions: array(string),
});

export const TransactionsSchema = type({
    services: array(ServiceOptionSchema),
    transactions: array(TransactionOptionSchema),
    assets: array(AssetOptionSchema),
});
export type TransactionsSchema = TypeOf<typeof TransactionsSchema>;
